module.exports = __webpack_public_path__ + "static/painoindeksilaskuri-aca633bb2b97e7141424d42c304cc639.png";